<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SFt6nm/images/9780446550376.jpg?1733085655606" alt="This image is the cover for the book Lady's Choice, Isles/Templars"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lady's Choice, Isles/Templars
      </h1>
      <p class="bookDescription body article font2">
        <p>Lady Sorcha Macleod is certain that the man her sister Adela loves, the dashing Scottish Knight Templar Sir Hugo Robinson, is the masked rider who kidnaps Adela on her wedding day. When she learns he is not, she sets off to rescue Adela with Hugo in hot pursuit. On the road with the irrepressible Sorcha, Hugo soon discovers a woman of fire and beauty, a woman he longs to touch and taste-but his honor forbids it, because he is bound by his vow to marry Adela. As a cruel mastermind plots to steal the Templars' storied treasure and keep Adela for himself, Sorcha and Hugo will risk everything, even their own destiny, to save her and to protect the Templars' long-held secret.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amanda Scott
      </h2>
      
      <p class="authorDescription body article">&amp;lt;DIV&amp;gt;&amp;lt;B&amp;gt;Amanda Scott&amp;lt;/B&amp;gt; is the author of over 62 romance novels and the recipient of the Romance Writers of America's prestigious RITA Award. She lives in Folsom, California, outside of Sacramento. She is a fourth-generation Californian.&amp;lt;/DIV&amp;gt;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grand Central Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?559ada08